module.exports = __webpack_public_path__ + "img/project-02-01.8079aa6a.png";